import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../reducers/user.reducers";
import formDataReducer from "../reducers/formData.reducers";
import priceReducer from "../reducers/price.reducers";
import openSaasReducer from "../reducers/openSaas.reducers";

const store = configureStore({
  reducer: {
    price: priceReducer,
    user: userReducer,
    formDataDic: formDataReducer,
    openSaas: openSaasReducer,
  },
});

export default store;
